import angular from 'npm/angular';
import Base from './base/base';
import Basic from './basic/basic';
import Floor from './floor/floor';
import Home from './home/home';
import Specifications from './specifications/specifications';
import Others from './others/others';
import Generator from './default.generator/default.generator';
import Login from './login/login';
import Tpin from './tpin/tpin';
import Quotes from './quotes/quotes';
import QuotesInterCity from './quotes-intercity/quotes-intercity';
import QuotesVehicle from './quotes-vehicle/quotes-vehicle';
import Location from './location/location';
import Payment from './payment/payment';
import Completion from './completion/completion';
import Failure from './failure/failure';
import Paylater from './paylater/paylater';
import Orders from './orders/orders';
import Options from './options/options';
import MoveStore from './movestore/movestore';
import Store from './store/store';
import Acknowledge from './acknowledge/acknowledge';
import Validate from './validate/validate';

let componentModule = angular.module('app.components', [
	Base.name,
	Basic.name,
	Floor.name,
    Home.name,
    Specifications.name,
    Others.name,
    Login.name,
    Tpin.name,
    Quotes.name,
    QuotesInterCity.name,
    QuotesVehicle.name,
    Location.name,
    Payment.name,
    Completion.name,
    Failure.name,
    Paylater.name,
    Orders.name,
    Acknowledge.name,
    Validate.name
]);

export default componentModule;


// WEBPACK FOOTER //
// ./client/app/components/components.js